import common from '../common'

export default {
    getUserInfo() {
      return common.get('/rocheManage/home/user/userInfo',{});
    },
}


// WEBPACK FOOTER //
// ./src/api/user/center.js